<template>
  <div>
    <DeviceSetupIntro
      v-if="currentStep === 1"
      @close="handleCancel"
      @next="handleStepForward"
    />
    <SelectDevice
      v-else-if="currentStep === 2"
      @back="handleStepBack"
      @next="handleStepForward"
      @onSelection="setSelectedOs"
    />
    <InstallOptions
      v-else-if="currentStep === 3"
      :selectedOs="selectedOs"
      @back="handleStepBack"
      @next="handleStepForward"
      @onInstallSelection="setSelectedInstall"
      @onOsSelection="setSelectedOs"
    />
    <component
      :is="selectedInstall.component"
      v-else-if="selectedInstall"
      :connectKey="connectKey"
      :kickstart="creationKickstart"
      :selectedInstall="selectedInstall"
      :selectedOs="selectedOs"
      @back="handleStepBack"
      @close="handleCancel"
    />
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { guidedSetupComponents } from 'client/Discover/components/GuidedSetup/GuidedSetupSettings';
import { mapState } from 'vuex';
import DeviceSetupIntro from 'client/Discover/components/GuidedSetup/DeviceSetupIntro.vue';
import InstallOptions from 'client/Discover/components/GuidedSetup/InstallOptions.vue';
import SelectDevice from 'client/Discover/components/GuidedSetup/SelectDevice.vue';

const { settings } = ItemTypeConsts;
const settingsModule = StoreModuleMap[settings];

export default {
  name: 'DeviceSetup',

  components: {
    ...guidedSetupComponents,
    DeviceSetupIntro,
    InstallOptions,
    SelectDevice,
  },

  props: {
    defaultOs: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentStep: 1,
      selectedOs: '',
      selectedInstall: {},
    };
  },

  computed: {
    ...mapState(settingsModule, [
      'connectKey',
      'kickstart',
    ]),

    creationKickstart() {
      return `${this.kickstart}/Kickstart`;
    },
  },

  created() {
    if (this.defaultOs) {
      this.selectedOs = this.defaultOs;
      this.currentStep = 3;
    }
  },

  methods: {
    handleCancel() {
      this.$emit('close');
    },

    handleStepBack() {
      this.currentStep -= 1;
    },

    handleStepForward() {
      this.currentStep += 1;
    },

    setSelectedInstall(option) {
      this.selectedInstall = option;
    },

    setSelectedOs(os) {
      this.selectedOs = os;
    },
  },
};
</script>
